import React, { Component } from 'react';
import Error from 'src/ui/library/Error';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) return <Error />;
    return this.props.children;
  }
}

export default ErrorBoundary;
